import {
  AutomaticMailStep,
  AutomaticMailStepAttributes,
  Step,
  StepAttributes,
} from 'api';
import moment from 'moment';
import React from 'react';
import * as Yup from 'yup';

interface AutomaticMailStepType extends Step {
  steppable: AutomaticMailStep;
}

interface Props {
  step: AutomaticMailStepType;
}

type StepFormAttributes = StepAttributes &
  AutomaticMailStepAttributes & {scheduleType: string};

const useStepForm = ({step}: Props) => {
  const convertValues = (values: StepFormAttributes) => {
    const attributes = Object.assign({}, values);
    if (values.scheduleType === 'isImmediately') {
      attributes.isImmediately = true;
      attributes.startDate = null;
      attributes.startDay = null;
      attributes.startHour = null;
      attributes.daysOfWeek = [];
    } else if (values.scheduleType === 'period') {
      attributes.startDate = null;
      attributes.isImmediately = false;
    } else {
      attributes.startDay = null;
      attributes.isImmediately = false;
    }
    delete attributes.scheduleType;
    delete attributes.eventToContinue;
    delete attributes.isContinuedByEvent;
    return attributes;
  };

  const today = React.useMemo(() => moment(), []);
  const initialValues = {
    name: step?.name || '',
    memo: step?.memo || '',
    scheduleType: step?.isImmediately
      ? 'isImmediately'
      : step?.startDate
        ? 'date'
        : 'period',
    startDay: step?.startDay || 1,
    startHour: step?.startHour || 9,
    startDate: step?.startDate ? moment(step?.startDate) : today,
    daysOfWeek: step?.daysOfWeek || [1, 2, 3, 4, 5],
    isImmediately: step?.isImmediately || false,
    isContinuedByEvent: step?.steppable.isContinuedByEvent || false,
    eventToContinue: step?.steppable.eventToContinue || '',
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('必須項目です'),
    daysOfWeek: Yup.array().when('scheduleType', {
      is: (scheduleType: string) => scheduleType === 'period',
      then: (schema) => schema.ensure().of(Yup.number()).min(1, '必須項目です'),
    }),
    eventToContinue: Yup.string().when('isContinuedByEvent', {
      is: (isContinuedByEvent: boolean) => isContinuedByEvent,
      then: (schema) => schema.required('必須項目です'),
    }),
  });

  return {
    convertValues,
    initialValues,
    validationSchema,
  };
};

export default useStepForm;
